import styled from "@emotion/styled";
import { flex } from "shared/theme/mixins";

export const IconWrapper = styled.div`
  cursor: pointer;
`;

export const IconListContainer = styled.div`
  flex-wrap: wrap;
  gap: 0.75rem;
  ${flex()}
`;
